<!--疑难卷信息设置-->
<template>
	<div class="puzzle-difficult">
		<div class="difficult-content">
			<ul class="content">
				<li
					class="list"
					v-for="(item, index) in puzzleList"
					:class="{ 'list-active': puzzleActiveIndex.includes(index) }"
					:key="index"
					@click="chosePuzzleInfo(item, index)"
				>
					{{ item }}
				</li>
			</ul>
			<div class="message">
				<el-input v-model="puzzledContentToStr" type="textarea" :rows="3" :maxlength="100" placeholder="请输入内容" show-word-limit> </el-input>
			</div>
			<div class="btn-box">
				<el-button type="success" style="color: white; background: #009688" @click="confirmPuzzle">确 定</el-button>
				<el-button type="danger" style="color: white;background: #FF7200;margin-left: 50px;" @click="quitPuzzle">取 消</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'puzzle-diffficult',
	data() {
		return {
			//疑难卷 list
			puzzleList: [],
			//选中的list
			puzzleActiveIndex: [],
			//显示的内容
			puzzledContent: [],
			//内容转化为str
			puzzledContentToStr: ''
		}
	},
	props: {
		paperType: null
	},
	watch: {
		paperType: {
			handler(val) {
				if (val === 1) {
					this.puzzleList = ['错误典型', '优秀试卷']
				} else if (val === -2) {
					this.puzzleList = ['图片颠倒', '图片模糊', '裁错题', '标志试卷', '文字不一致', '其他异常试卷']
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		chosePuzzleInfo(val, index) {
			if (this.puzzleActiveIndex.includes(index)) {
				this.puzzleActiveIndex.splice(
					this.puzzleActiveIndex.findIndex(item => item === index),
					1
				)
				this.puzzledContent.splice(
					this.puzzledContent.findIndex(item => item === val),
					1
				)
			} else {
				this.puzzleActiveIndex.push(index)
				this.puzzledContent.push(val)
			}
			this.puzzledContentToStr = this.puzzledContent.toString()
		},
		quitPuzzle() {
			this.puzzledContent = []
			this.puzzleActiveIndex = []
			this.puzzledContentToStr = ''
			this.eventBus.$emit('isTypical', { state: false, text: '' })
			this.$emit('input', false)
		},
		confirmPuzzle() {
			this.$emit('confirmPuzzleDiff', this.puzzledContentToStr)
			this.$emit('input', false)
		}
	}
}
</script>

<style scoped lang="less">
.puzzle-difficult {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 100;
	background: rgba(0, 0, 0, 0.7);
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 0 10px #b9b4b4;
	.difficult-content {
		width: 500px;
		background: white;
		padding: 15px;
		border-radius: 10px;
	}
	.content {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	.list {
		width: 240px;
		height: 50px;
		line-height: 50px;
		font-size: 17px;
		color: black;
		text-align: center;
		background: #cbeade;
		border-radius: 12px;
		margin-bottom: 20px;
		&:hover {
			cursor: pointer;
		}
		&:nth-child(2n + 1) {
			margin-right: 20px;
		}
	}
	.list-active {
		background: #009688;
		color: white;
	}
	.btn-box {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}
}
</style>
